import { getResponseHeader } from '~/lib/utils/fetch';

export const useTrophiesHeader = () => {
  const storedItems = useNomadStorage('trophies', []);

  const update = (response) => {
    const trophyHeader = getResponseHeader(response, AdamHeader.NomadTrophies);

    const lowPrioTrophiesHeader = getResponseHeader(
      response,
      AdamHeader.NomadLowPrioTrophies
    );

    const trophiesIds = trophyHeader
      ? trophyHeader.split(',').map((id) => id.trim())
      : [];

    let lowPrioIds = [];
    if (lowPrioTrophiesHeader) {
      lowPrioIds = lowPrioTrophiesHeader.split(',').map((id) => id.trim());
    }

    const highlightItems = trophiesIds.reduce((items, item) => {
      if (item.length) {
        items.push({
          id: item,
          highlight: true,
        });
      }
      return items;
    }, []);

    const lowItems = lowPrioIds.reduce((items, item) => {
      if (item.length) {
        items.push({
          id: item,
          highlight: false,
        });
      }
      return items;
    }, []);

    storedItems.value = [...storedItems.value, ...lowItems, ...highlightItems];
  };

  const clear = () => {
    storedItems.value = [];
  };

  const hasHighlightedItems = computed(() => {
    return storedItems.value.some((item) => item.highlight);
  });

  const ids = computed(() => {
    return storedItems.value.map((item) => item.id);
  });

  return {
    update,
    hasHighlightedItems,
    ids,
    clear,
  };
};
